import { useState } from 'react';
import { Box } from '@mui/material';
import { CasBaseDialog, CasLoaderWithBackdrop } from 'src/compass/shared/components';
import useRetrieve from 'src/compass/shared/hooks/reactQuery/useRetrieve';
import useUpdateMutation from 'src/compass/shared/hooks/reactQuery/useUpdateMutation';
import ClaimDetails from './ClaimDetails';
import { getColumnColorByReinsuranceYear } from './ClaimListing';

interface ClaimDetailsDialogProps {
  onClose: VoidFunction;
  id: number;
  autoCheckout?: boolean;
}

export default function ClaimDetailsDialog({ onClose: paramOnClose, autoCheckout, id }: ClaimDetailsDialogProps) {
  const [sendAutoCheckout, setSendAutoCheckout] = useState(autoCheckout);

  const queryResult = useRetrieve({
    url: 'Sce/Claims',
    params: { id, autoCheckout: sendAutoCheckout },
    onSuccess: (response: any) => {
      if (sendAutoCheckout) setSendAutoCheckout(false); 
      return response;
    },
  });

  const { data, isLoading, isRefetching, isError, refetch } = queryResult;

  const { mutate: autoCheckinMutate } = useUpdateMutation({
    url: '/Sce/Claims/Checkout',
    onSuccess: paramOnClose,
    onError: paramOnClose,
  });

  const onClose = () => {
    if (autoCheckout)
      autoCheckinMutate({ endorsementId: id, auto: true, action: 'Clear' });
    else paramOnClose();
  };

  if (isLoading) return <CasLoaderWithBackdrop />;

  if (isError) throw new Error('Error retrieving data from the server.');

  const { insuredName, reinsuranceYear, policyNumber, sce } = data;
  
  return (
    <CasBaseDialog
      open
      maxWidth="xl"
      onClose={onClose}
      title={<Box>{insuredName}: <span style={getColumnColorByReinsuranceYear(data)}>{reinsuranceYear}</span>-{policyNumber}-{sce}</Box>}
      showCloseIcon
    > 
      {isRefetching && <CasLoaderWithBackdrop/> }
      <ClaimDetails data={data} onUpdated={refetch}/> 
    </CasBaseDialog>
  );
}
